import { LegacyGatewayBase } from './base'
import { toAreaProps } from './translator/area'
import { toOptionsProps } from './translator/options'
import { GetArea, GetAreas } from '@/infrastructure/network/Legacy/requests/area'
import { EmptyOptionsPropsFactory, IParamsProps } from '@/entities/Legacy/Options'

export default class Area extends LegacyGatewayBase {
  async GetArea(id: string) {
    const { area } = await this.apiClient.request(new GetArea(id))
    return area ? toAreaProps(area) : null
  }

  async GetAreas(props: IParamsProps) {
    const { areas, options } = await this.apiClient.request(new GetAreas(props))
    return {
      items: areas ? areas.map((prop) => toAreaProps(prop)) : [],
      options: options ? toOptionsProps(options) : EmptyOptionsPropsFactory()
    }
  }
}
